var styles = {"fontElementMap":"XkSZF","orderedlist":"JnJhF","bulletedlist":"_7Cqm8","listItem":"SHhZH"};

export { styles as s };
//# sourceMappingURL=lists-d95a107a.js.map
